<template>
  <li
    :class="[
      'snap-nav-item',
      {
        'snap-nav-item--disabled': disabled,
        active: active
      }
    ]"
    @click="handleClick"
  >
    <span class="item-label">
      <slot />
    </span>
  </li>
</template>

<script>
export default {
  name: 'VSnapNavItem',
  props: {
    name: {
      type: [String, Number],
      default: ''
    },
    // 标记组件顺序
    order: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: false
    }
  },
  watch: {
    disabled() {
      this.$parent.updateChild()
    },
    name() {
      this.$parent.updateChild()
    }
  },
  methods: {
    setActive(active = true) {
      this.active = active
    },
    handleClick() {
      if (this.disabled) return
      this.$parent.$emit('changeItem', this)
      this.$emit('click')
    }
  }
}
</script>

<style lang="less">
.snap-nav-item {
  display: inline-block;
  padding: 4px 10px;
  color: #999;
  cursor: pointer;
  font-size: 12px;
  text-align: center;

  &.active {
    color: #ffca27;
    font-weight: 700;
  }
}
</style>
